// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__37Cuq","productName":"Table_productName__1nFAM"};